import { render, staticRenderFns } from "./TwViewPattern.vue?vue&type=template&id=1a8994b3&"
import script from "./TwViewPattern.vue?vue&type=script&lang=js&"
export * from "./TwViewPattern.vue?vue&type=script&lang=js&"
import style0 from "./TwViewPattern.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports